export default __webpack_public_path__ + "static/media/iqos-ads.ad1b4e26.png";